import { AddCircleOutline } from '@mui/icons-material';
import { Divider, ListItem, Menu, MenuItem, Typography } from '@mui/material';
import { Fragment, useCallback, useState } from 'react';
import { useNavigate } from 'react-router';

const MenuAddMunicipality = (): React.ReactElement => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);

  const navigate = useNavigate();

  const open = Boolean(anchorEl);

  const handleClick = useCallback(
    (event: React.MouseEvent<HTMLElement>) => {
      event.preventDefault();
      event.stopPropagation();
      setAnchorEl(event.currentTarget);
    },
    [setAnchorEl]
  );

  const handleClose = useCallback(
    (event) => {
      event.preventDefault();
      event.stopPropagation();
      return new Promise((resolve) => resolve(setAnchorEl(null)));
    },
    [setAnchorEl]
  );

  return (
    <Fragment>
      <ListItem
        style={{ padding: '0' }}
        button
        onClick={handleClick}
        id="menu-add-municipality-button"
      >
        <div className="pmi-d-flex pmi-p-2">
          <AddCircleOutline color="primary" />
        </div>
        <Typography color="primary.main" className=" pmi-pl-0 pmi-py-2 pmi-pr-2">
          Aggiungi nuovo comune
        </Typography>
      </ListItem>
      <Menu
        id="menu-add-municipality"
        MenuListProps={{
          'aria-labelledby': 'menu-add-municipality-button',
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <MenuItem
          onClick={(event) => {
            handleClose(event).then(() => {
              navigate('/sistema/geografiche/comune/italia/nuovo');
            });
          }}
          disableRipple
        >
          Italiano
        </MenuItem>
        <Divider key="new-italian-divider" />
        <MenuItem
          onClick={(event) => {
            handleClose(event).then(() => {
              navigate('/sistema/geografiche/comune/estero/nuovo');
            });
          }}
          disableRipple
        >
          Estero
        </MenuItem>
        <Divider key="new-foreign-divider" />
        <MenuItem
          onClick={(event) => {
            handleClose(event).then(() => {
              navigate('/sistema/geografiche/comune/soppresso/nuovo');
            });
          }}
          disableRipple
        >
          Soppresso
        </MenuItem>
      </Menu>
    </Fragment>
  );
};

MenuAddMunicipality.displayName = 'Menu Add Municipality component';

export default MenuAddMunicipality;
